import { render, staticRenderFns } from "./CompetitionProgram.vue?vue&type=template&id=7971c2a6&"
import script from "./CompetitionProgram.vue?vue&type=script&lang=js&"
export * from "./CompetitionProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports